import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Authority} from './interface/authority';
import {Judiciary} from './interface/judiciary';

@Injectable({
	providedIn: 'root',
})
export class HeimdallService {
	private static readonly _authorityResolver$: Subject<null> =
		new Subject<null>();

	private _authority: Authority = {
		superuser: false,
		admin: false,
		user: false,
		guest: false,
	};

	private readonly _judiciary: Judiciary = {
		dashboard: { hasJurisdiction: false },
	};

	private static roleSUADUSGU(authority: Authority): boolean {
		return (
			authority.superuser ||
			authority.admin ||
			authority.user ||
			authority.guest
		);
	}

	private static roleSUAD(authority: Authority): boolean {
		return authority.superuser || authority.admin;
	}

	private static roleSUUS(authority: Authority): boolean {
		return authority.superuser || authority.user;
	}

	constructor() {}

	public prepareJudiciary(authority: Authority): void {
		this._authority = authority;
		this._judiciary.dashboard.hasJurisdiction = HeimdallService.roleSUAD(authority);
	}

	public isAuthoritySet(): boolean {
		return (
			this._authority.superuser ||
			this._authority.admin ||
			this._authority.user ||
			this._authority.guest
		);
	}

	public reset(): void {
		this._authority = {
			superuser: false,
			admin: false,
			user: false,
			guest: false,
		};

		this.prepareJudiciary(this._authority);
		HeimdallService._authorityResolver$.next(null);
	}

	public get judiciary(): Judiciary {
		return this._judiciary;
	}

	static get authResolver$(): Subject<null> {
		return HeimdallService._authorityResolver$;
	}
}
